<template>
  <div
    :class="disabled ? 'radio__disabled' : ''"
    class="radio__container"
    @click="optionClicked">
    <input
      type="radio"
      :id="value"
      :name="groupName"
      :checked="selected"
      @change="optionClicked"
    >
    <label class="radio__label">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Boolean, Number, String, Object, Array],
      default: null
    },

    groupName: {
      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    value: 'updateOption'
  },

  data () {
    return {
      selected: false
    }
  },

  created () {
    this.registerOption()
  },

  destroyed () {
    this.unregisterOption()
  },

  methods: {
    valueUpdated (value) {
      this.selected = this.value === value
    },

    registerOption () {
      this.$parent.registerOption({ instance: this, value: this.value })
    },

    unregisterOption () {
      this.$parent.unregisterOption({ instance: this, value: this.value })
    },

    updateOption () {
      this.$parent.updateOption({ instance: this, value: this.value })
    },

    optionClicked () {
      if (!this.disabled) {
        this.$parent.optionClicked({ instance: this, value: this.value })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styling/styling.scss';

.radio {
  &__container {
    width: 100%;
    height: rem(25);

    [type="radio"]:checked,
    [type="radio"]:not(:checked) {
      left: rem(-9999);
      position: absolute;
    }

    [type="radio"]:checked + label,
    [type="radio"]:not(:checked) + label {
      cursor: pointer;
      font-size: rem(13);
      position: relative;
      line-height: rem(25);
      padding-left: rem(25);
      display: inline-block;
      color: $medium-grey-font;
    }

    [type="radio"]:checked + label:before,
    [type="radio"]:not(:checked) + label:before {
      width: rem(16);
      height: rem(16);
      left: 0;
      content: '';
      top: rem(4);
      position: absolute;
      background: $white;
      border-radius: 100%;
      box-sizing: border-box;
      border: rem(1) solid $radio-border;
    }

    [type="radio"]:checked + label:after,
    [type="radio"]:not(:checked) + label:after {
      content: '';
      width: rem(8);
      height: rem(8);
      top: rem(8);
      left: rem(4);
      position: absolute;
      border-radius: 100%;
      box-sizing: border-box;
      background: $medium-grey-font;
    }

    [type="radio"]:checked + label:before { border-color: $medium-grey-font; }

    [type="radio"]:not(:checked) + label:after { opacity: 0; }

    [type="radio"]:checked + label:after { opacity: 1; }
  }

  &__label:hover { color: $dark-grey-font; }

  &__disabled {
    position: relative;

    .radio__label {
      color: $dark-grey-background;
      border-color: $dark-grey-background;
    }

    &:after {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      content: '';
      position: absolute;
    }

    [type="radio"]:checked + label,
    [type="radio"]:not(:checked) + label {
      color: $dark-grey-background;
      border-color: $dark-grey-background;
    }

    [type="radio"]:checked + label:before,
    [type="radio"]:not(:checked) + label:before { border-color: $dark-grey-background; }

    [type="radio"]:checked + label:after,
    [type="radio"]:not(:checked) + label:after { background-color: $dark-grey-background; }

    &:hover { cursor: not-allowed; }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Radio/RadioOption.vue